import { createFileRoute } from '@tanstack/react-router';
import { EshopExtractionPage } from '@features/admin/eshop-extraction';

export const Route = createFileRoute('/admin/eshop-extraction/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EshopExtractionPage />;
}
